import React from "react";

const About = () => (
	<section className="py-16 px-4 max-w-5xl mx-auto" id="about">
		<h3 className="text-3xl font-semibold mb-4">About Us</h3>
		<p className="text-slate-700 font-semibold">
			INOVATIVA COMPANY LIMITED is a forward-thinking IT company specializing in
			delivering enterprise solutions, digital transformation, and managed
			services. Our team of experts is committed to helping businesses leverage
			technology for success.
		</p>
	</section>
);

export default About;
